import { createSingleFlightQueue } from './singleFlightQueue'

/**
 * File d'attente globale pour garantir 1 seul appel API à la fois
 * (utile quand le backend rate-limit la concurrence à 1).
 */
export const apiSingleFlight = createSingleFlightQueue()
